/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import TableList from '~/components/tableList';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { ConsultUserSearchMinimalDataResponse } from '~/services/consult/user/search/response';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import { IListColCampaing } from '~/views/Resource/Campaing/model';
import { TitleCategory } from './Detail/styles';

import bronzeMedal from '../../../assets/svg/bronze-medal.svg';
import goldMedal from '../../../assets/svg/gold-medal.svg';
import silverMedal from '../../../assets/svg/silver-medal.svg';

import * as St from './styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: string;
}

const ConsultUser = () => {
  const history = useHistory();
  const [list, setList] = useState([]);

  const [form, setForm] = useState<Form>({
    cpf: { name: 'cpf', value: '' },
    numeroCartao: { name: 'numeroCartao', value: '' },
    nome: '',
  });

  const handleGenerateURL = useMemo(() => {
    if (form.cpf?.unmasked && form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUserProductMinimalData}?cpf=${form.cpf?.unmasked}&numeroCartao=${form.numeroCartao?.unmasked}&nome=${form.nome}`;
    }

    if (!form.cpf?.unmasked && form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUserProductMinimalData}?numeroCartao=${form.numeroCartao?.unmasked}&nome=${form.nome}`;
    }

    if (form.cpf?.unmasked && !form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUserProductMinimalData}?cpf=${form.cpf?.unmasked}&nome=${form.nome}`;
    }

    if (form.cpf?.unmasked && form.numeroCartao?.unmasked && !form.nome) {
      return `${Endpoints.consult.searchUserProductMinimalData}?cpf=${form.cpf?.unmasked}&numeroCartao=${form.numeroCartao?.unmasked}`;
    }

    if (!form.cpf?.unmasked && !form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUserProductMinimalData}?nome=${form.nome}`;
    }

    if (form.cpf?.unmasked && !form.numeroCartao?.unmasked && !form.nome) {
      return `${Endpoints.consult.searchUserProductMinimalData}?cpf=${form.cpf?.unmasked}`;
    }

    return `${Endpoints.consult.searchUserProductMinimalData}?numeroCartao=${form.numeroCartao?.unmasked}`;
  }, [form]);

  const api = useApi<ConsultUserSearchMinimalDataResponse[]>(
    handleGenerateURL,
    ApiMethod.GET,
  );

  const customerHeader = [
    {
      id: 0,
      maxChar: 6,
      textAlign: 'center',
    },
    {
      id: 1,
      value: 'Nome completo',
      maxChar: 30,
      textAlign: 'left',
    },
    {
      id: 2,
      value: 'Data do cadastro',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Canal',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Status do cartão',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Produtos contratados',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 6,
      value: 'Ação',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  useEffect(() => {
    loadData();
  }, [api.loading]);

  const searchUserProduct = () => api.callApi();

  const goToDetail = (a: any, item: any) => {
    history.push('/consult/user/detail', {
      cpf: item.cpf,
      produtos: item.produtos,
    });
  };

  const loadData = () => {
    if (api.status !== 200) {
      setList([]);
      return;
    }

    const dataRes = api.data as ConsultUserSearchMinimalDataResponse[];

    const newList = [];

    dataRes.forEach((data, clientIndex) => {
      const isLastClient = clientIndex === dataRes.length - 1;
      let nivel = '';

      switch (data.nivel) {
        case 'Sem Classificação':
          nivel = '';
          break;
        case 'Nível ouro':
          nivel = goldMedal;
          break;
        case 'Nível prata':
          nivel = silverMedal;
          break;
        case 'Nível bronze':
          nivel = bronzeMedal;
          break;
        default:
          nivel = '';
      }

      const produtos = data.produtos || [];

      if (produtos.length === 0) {
        const item: IListColCampaing[] = [
          {
            type: nivel !== '' && 'icon',
            icon: nivel,
            maxChar: 6,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            border: true,
            title: 'Nome completo',
            value: data.nome,
            maxChar: 30,
            textAlign: 'left',
            isLastRowOfGroup: !isLastClient,
          },
          {
            border: true,
            title: 'Data do cadastro',
            value: '-',
            maxChar: 15,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            border: true,
            title: 'Canal',
            value: '-',
            maxChar: 20,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            title: 'Status do cartão',
            value: '-',
            maxChar: 30,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            title: 'Produtos contratados',
            value: '-',
            maxChar: 30,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            item: data,
            maxChar: 8,
            textAlign: 'right',
            searchAction: goToDetail,
            isLastRowOfGroup: !isLastClient,
          },
        ];
        newList.push(item);
      } else {
        const totalRows = produtos.length;

        produtos.forEach((produto, index) => {
          const isFirstRow = index === 0;
          const isLastRow = index === totalRows - 1;

          const item: IListColCampaing[] = [
            {
              type: isFirstRow && nivel !== '' ? 'icon' : undefined,
              icon: isFirstRow ? nivel : undefined,
              maxChar: 6,
              textAlign: 'center',
              rowSpan: isFirstRow ? totalRows : undefined,
              hidden: !isFirstRow,
              isLastRowOfGroup: isFirstRow && !isLastClient,
            },
            {
              border: true,
              title: 'Nome completo',
              value: data.nome,
              maxChar: 30,
              textAlign: 'left',
              rowSpan: isFirstRow ? totalRows : undefined,
              hidden: !isFirstRow,
              isLastRowOfGroup: isFirstRow && !isLastClient,
            },
            {
              border: true,
              title: 'Data do cadastro',
              value: produto.dataAdesao || '-',
              maxChar: 15,
              textAlign: 'center',
              showBottomBorder: !isLastRow,
              isLastRowOfGroup: isLastRow && !isLastClient,
            },
            {
              border: true,
              title: 'Canal',
              value: produto.origem || '-',
              maxChar: 20,
              textAlign: 'center',
              showBottomBorder: !isLastRow,
              isLastRowOfGroup: isLastRow && !isLastClient,
            },
            {
              title: 'Status do cartão',
              value: produto.status || '-',
              maxChar: 30,
              textAlign: 'center',
              showBottomBorder: !isLastRow,
              isLastRowOfGroup: isLastRow && !isLastClient,
            },
            {
              title: 'Produtos contratados',
              value: produto.nome || '-',
              maxChar: 30,
              textAlign: 'center',
              showBottomBorder: !isLastRow,
              isLastRowOfGroup: isLastRow && !isLastClient,
            },
            {
              item: data,
              maxChar: 8,
              textAlign: 'right',
              searchAction: goToDetail,
              rowSpan: isFirstRow ? totalRows : undefined,
              hidden: !isFirstRow,
              isLastRowOfGroup: isFirstRow && !isLastClient,
            },
          ];

          newList.push(item);
        });
      }
    });

    setList(newList);
  };

  return (
    <>
      <Loading status={api.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                name={form.cpf.name}
                value={form.cpf.value}
                onChange={(e) => setFormState(e, form, setForm)}
                placeholder="000.000.000-00"
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                name={form.numeroCartao.name}
                value={form.numeroCartao.value}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Nome"
                name="Nome"
                value={form.nome}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Button
                fitContent
                onClick={searchUserProduct}
                loading={api.loading}
                disabled={
                  (form.cpf.value.length !== 14 &&
                    form.numeroCartao.value.length !== 19 &&
                    !form.nome) ||
                  api.loading
                }
              >
                <span>Consultar</span>
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {list.length <= 0 ? (
          <St.BoxCard>
            <ContainerFlex center>
              <TitleCategory>Cliente não encontrado</TitleCategory>
            </ContainerFlex>
          </St.BoxCard>
        ) : (
          <St.BoxCard>
            <ContainerFlex row>
              {api.status === 404 && (
                <ContainerFlex center marginTop={30}>
                  <TitleCategory>{api.data?.mensagem}</TitleCategory>
                </ContainerFlex>
              )}

              {list.length > 0 && (
                <TableList
                  customerHeader={customerHeader}
                  list={list}
                  disableRowShadow
                />
              )}
            </ContainerFlex>
          </St.BoxCard>
        )}
      </Container>
    </>
  );
};

export default ConsultUser;
